import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreComponent } from './core.component';
import { ByPassSecurityPipe } from './pipes/by-pass-security.pipe';
import { DashWhenEmptyPipe } from './pipes/dash-when-empty.pipe';
import { TextMarkPipe } from './pipes/text-mark.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { ArrayToListPipe } from './pipes/array-to-list.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { Nl2brPipe } from './pipes/nl2br.pipe';
import { AnonymizedCandidatePipe } from './pipes/anonymized-candidate';
import { IsCheckedPipe } from './pipes/is-checked';
import { TimezonePipe } from './pipes/timezone.pipe';
import { AppVersionBannerComponent } from './components/app-version-banner/app-version-banner.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    CoreComponent,
    ByPassSecurityPipe,
    TextMarkPipe,
    DashWhenEmptyPipe,
    AnonymizedCandidatePipe,
    IsCheckedPipe,
    ReplacePipe,
    ArrayToListPipe,
    PhoneNumberPipe,
    Nl2brPipe,
    TimezonePipe,
    AppVersionBannerComponent
],
  imports: [
    CommonModule,
    TranslocoModule
  ],
  exports: [
    CoreComponent,
    ByPassSecurityPipe,
    TextMarkPipe,
    DashWhenEmptyPipe,
    AnonymizedCandidatePipe,
    IsCheckedPipe,
    ReplacePipe,
    ArrayToListPipe,
    PhoneNumberPipe,
    Nl2brPipe,
    TimezonePipe,
    AppVersionBannerComponent
  ]
})
export class CoreModule { }
